import { memo, type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import { Loader } from '../../../../Elements/Loader/index.tsx';
import { formatNumber } from '../../../../utils/formatNumber.ts';
import { PageInfoWrapper } from './styled.ts';
import type { PageInfoProps } from './types.ts';

export const PageInfo: FC<PageInfoProps> = memo(function PageInfo({ from, to, total, isLoading, dataTestId }) {
  const isMobile = useMediaQuery({ query: Media.xsMax });

  return (
    <PageInfoWrapper data-testid={dataTestId}>
      {isLoading && <Loader cover />}
      {!isMobile && (total ? `${formatNumber(from)} - ${formatNumber(to)} / ${formatNumber(total)}` : `0 / 0`)}
      {isMobile && (total ? `${formatNumber(from)}-${formatNumber(to)}/${formatNumber(total)}` : `0/0`)}
    </PageInfoWrapper>
  );
});
